import { useState, useEffect } from 'react';

/**
 * Hook to detect if the screen is small based on window width
 * @param breakpoint - The width breakpoint to consider as small screen (default: 1300)
 * @returns boolean indicating if the screen is small
 */
export default function useSmallScreen(breakpoint: number = 1300): boolean {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < breakpoint);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, [breakpoint]);

  return isSmallScreen;
}
